import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { api } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";

export default function Home() {
  const { t, lang } = useLanguage();
  const [featured, setFeatured] = useState([]);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    api.get("/products", { params: { featured: true } }).then(({ data }) => setFeatured(data));
    api.get("/categories").then(({ data }) => setCategories(data)).catch(() => {});
  }, []);

  return (
    <div className="page-enter">
      {/* HERO */}
      <section className="relative overflow-hidden">
        <div
          className="absolute inset-0 opacity-25"
          style={{
            backgroundImage: "url(https://images.pexels.com/photos/3612930/pexels-photo-3612930.jpeg)",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0B]/40 via-[#0A0A0B]/85 to-[#0A0A0B]" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-10 py-24 lg:py-32">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 border border-[#D4AF37]/40 rounded-full text-xs uppercase tracking-widest text-[#D4AF37] mb-6">
              <Sparkles size={14} />
              {t("heroEyebrow")}
            </div>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-7xl font-bold leading-[1.05] mb-6">
              {t("heroTitle")}
            </h1>
            <p className="text-base sm:text-lg text-[#9CA3AF] leading-relaxed mb-10 max-w-2xl">
              {t("heroSub")}
            </p>
            <div className="flex flex-wrap gap-4">
              <Link to="/shop" data-testid="hero-shop-btn" className="btn-gold px-8 py-3.5 rounded-full inline-flex items-center gap-2">
                {t("shopNow")}
                <ArrowRight size={18} className={lang === "ar" ? "rotate-180" : ""} />
              </Link>
              <a href="#categories" data-testid="hero-categories-btn" className="btn-outline-gold px-8 py-3.5 rounded-full">
                {t("exploreCategories")}
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* CATEGORIES */}
      <section id="categories" className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
        <div className="flex items-end justify-between mb-10">
          <div>
            <div className="text-xs uppercase tracking-widest text-[#D4AF37] mb-2">M16</div>
            <h2 className="font-display text-3xl lg:text-4xl">{t("categories")}</h2>
          </div>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-5 gap-4 stagger">
          {categories.map((c) => (
            <Link
              key={c.key}
              to={`/shop/${c.key}`}
              data-testid={`category-${c.key}`}
              className="group relative overflow-hidden rounded-2xl border border-[#27272A] hover-lift aspect-[3/4]"
            >
              <img src={c.image_url} alt={t(c.key)} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0B] via-[#0A0A0B]/30 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <div className="font-display text-xl mb-1">{t(c.key)}</div>
                <div className="flex items-center gap-1 text-xs text-[#D4AF37]">
                  {t("viewAll")} <ArrowRight size={12} className={lang === "ar" ? "rotate-180" : ""} />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>

      {/* FEATURED */}
    </div>
  );
}
